import * as React from "react";
import { Children, cloneElement, SetStateAction, Dispatch } from "react";
import "./actionButtons.scss";
import { formatDate } from "src/util/Date.helper";
import * as _ from 'lodash';
import { ViewExpenseItemsTable } from './Details/ViewExpenseItemsTable/ViewExpenseItemsTable';
import { ExpenseGeneralInfo } from './Details/ExpenseGeneralInfo/ExpenseGeneralInfo';
import { ExpensePaymentInfo } from './Details/ExpensePaymentInfo/ExpensePaymentInfo';
import { ExpenseInfo } from './Details/ExpenseInfo/ExpenseInfo';
import { DownloadExpenseDocuments } from './Details/DownloadExpenseDocuments/DownloadExpenseDocuments';
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';

interface IExpenseDetailViewProps {
  currentExpense: IExpenseDetail;
  onChangeCurrentValue: (value: IExpenseDetail) => void;
  setLoading: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  updateList: () => void;
  reloadExpense: (expenseId: number) => void;
  dateHeader?: React.FC<{ expense: IExpenseDetail }>;
}

export const ExpenseDetailView: React.FC<IExpenseDetailViewProps> = ({
  currentExpense: expense,
  setLoading,
  loading,
  updateList,
  onChangeCurrentValue,
  reloadExpense,
  dateHeader: DateHeader,
  children,
}) => {

  const ComponentsWithProps = Children.map(children, (child: React.DetailedReactHTMLElement<any, HTMLElement>) =>
    cloneElement(child, { expense, setLoading, reloadList: updateList, reloadExpense, onMoveStatus: onChangeCurrentValue })
  );

  return (
    <>
      <div className="header">
        <div className="left">
          <span className="id-header">ID da solicitação de pagamento</span>
          <span className="id">{expense.id}</span>
        </div>
        <div className="right">
          {DateHeader ? (
            <DateHeader expense={expense} />
          ) : (
              <>
                <span className="date-header">Última atualização</span>
                <span className="date">{expense?.lastUpdate ? formatDate(expense?.lastUpdate) : formatDate(expense.createdDate)}</span>
              </>
            )}
        </div>
      </div>
      <div className="row">
        <div className="region-container action-buttons">
          <span className="subtitle">Ações</span>
          <div className="extra-actions">{ComponentsWithProps}</div>
        </div>
      </div>

      <>
        <div className="row">
          <div className="col pricing-info">
            <ExpenseGeneralInfo
              expense={expense}
            />
          </div>
          <div className="col documents">
            <ExpenseInfo
              bankData={expense.bankData}
              invoiceNumber={expense.invoice.number}
              maturityDate={expense.invoice.maturityDate}
              totalValue={expense.invoice.totalValue}
              approvalUser={expense.approvalUser}
            />
          </div>
        </div>

        <div className="row">
          <div className="col pricing-info">
            {expense.expensePayment && <ExpensePaymentInfo expensePayment={expense.expensePayment} />}

          </div>
          <div className="col documents">
            <DownloadExpenseDocuments documents={expense.documents} />
          </div>
        </div>

        <div style={{ marginTop: '-13rem' }}>
          <ViewExpenseItemsTable
            loading={loading}
            expenseItems={expense.items}
          />
        </div>
      </>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/ExpenseDetailView.tsx